import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  close1s6qtnweux4fu as close,
  ObjectPool3iks1t8z0qq3m as ObjectPool,
} from './Pool.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultPoolClass;
function DefaultPool() {
  if (DefaultPoolClass === VOID) {
    class $ {
      constructor(capacity) {
        this.s4l_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.s4l_1;
        tmp.t4l_1 = Array(size);
        this.u4l_1 = 0;
      }
      v4l(instance) {
      }
      w4l(instance) {
        return instance;
      }
      x4l(instance) {
      }
      y4l() {
        if (this.u4l_1 === 0)
          return this.r4l();
        this.u4l_1 = this.u4l_1 - 1 | 0;
        var idx = this.u4l_1;
        var tmp = this.t4l_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.t4l_1[idx] = null;
        return this.w4l(instance);
      }
      z4l(instance) {
        this.x4l(instance);
        if (this.u4l_1 === this.s4l_1) {
          this.v4l(instance);
        } else {
          var _unary__edvuaz = this.u4l_1;
          this.u4l_1 = _unary__edvuaz + 1 | 0;
          this.t4l_1[_unary__edvuaz] = instance;
        }
      }
      oz() {
        var inductionVariable = 0;
        var last = this.u4l_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.t4l_1[i];
            var instance = !(tmp == null) ? tmp : THROW_CCE();
            this.t4l_1[i] = null;
            this.v4l(instance);
          }
           while (inductionVariable < last);
        this.u4l_1 = 0;
      }
    }
    protoOf($).l6 = close;
    initMetadataForClass($, 'DefaultPool', VOID, VOID, [ObjectPool()]);
    DefaultPoolClass = $;
  }
  return DefaultPoolClass;
}
//region block: exports
export {
  DefaultPool as DefaultPool2gb1fm4epwgu9,
};
//endregion

//# sourceMappingURL=DefaultPool.mjs.map
